// @flow
import * as React from 'react';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import { Box } from 'grommet';
import cableAndFiberMessages from 'esm-web-pro/messages/cableAndFiberMessages';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import { injectIntl, IntlShape } from 'react-intl';
import DisconnectIcon from 'esm-web-pro/components/layout/sidePanel/icons/DisconnectIcon';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import ConnectIcon from 'esm-web-pro/components/layout/sidePanel/icons/ConnectIcon';
import MeatballsIcon from 'esm-web-pro/components/layout/sidePanel/icons/MeatballsIcon';
import { withRouter } from 'react-router-dom';
import type { RouterHistory, Match } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { POINT12_CONTENT_TOOLTIP_KEY }
    from 'esm-web-pro/containers/pages/network/objects/point12/CableList/Point12CableList';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';

type Props = {
    intl: IntlShape,
    fiber: Object,
    intl: injectIntl,
    getFiberCableSeq: Function,
    parentRowId: string,
    history: RouterHistory,
    match: Match,
    padLevel?: 1 | 2 | 3,
    allowSplicing?: boolean,
    map: Object,
    onConnect: Function,
    onDisconnect: Function,
    cables: Object,
    loading?: boolean,
}

const OpticalPortSplicedFiberRow = (props: Props) => {
    const {
        intl: { formatMessage }, fiber, getFiberCableSeq,
        parentRowId, history, match, padLevel, allowSplicing, map: networkMap,
        onConnect, onDisconnect, cables, loading,
    } = props;

    const rowId = `${parentRowId}-fiber`;
    const cableSequence = fiber && getFiberCableSeq(fiber.container);

    const getActions = () => {
        if (fiber) {
            const actions = [{
                key: `${fiber.uuid}-more`,
                icon: <MeatballsIcon />,
                size: '20px',
                width: '3px',
                callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                    e.stopPropagation();
                    const path = match.url.split('/layer');
                    history.push(`${path[0]}/layer/fiber/${fiber.identity}`);
                },
                tooltip: formatMessage(actionMessages.more),
                tooltipKey: POINT12_CONTENT_TOOLTIP_KEY,
            }];

            if (networkMap.is_draft) {
                actions.splice(0, 0, {
                    key: `${fiber.uuid}-break`,
                    icon: <DisconnectIcon />,
                    callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                        e.stopPropagation();
                        onDisconnect();
                    },
                    size: '20px',
                    width: '3px',
                    tooltip: formatMessage(actionMessages.disconnect),
                    tooltipKey: POINT12_CONTENT_TOOLTIP_KEY,
                    disabled: loading,
                    loading,
                });
            }
            return actions;
        }

        if (allowSplicing && networkMap.is_draft) {
            return [
                {
                    key: `${parentRowId}-fiber-connect`,
                    icon: <ConnectIcon />,
                    callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                        e.stopPropagation();
                        onConnect();
                    },
                    size: '20px',
                    width: '3px',
                    tooltip: formatMessage(actionMessages.connect),
                    tooltipKey: POINT12_CONTENT_TOOLTIP_KEY,
                    disabled: loading
                        || !(cables && Object.values(cables).find((c) => !isEmpty(c.free_fibers) && !c.patch)),
                    loading,
                },
            ];
        }
        return [];
    };

    return (
        <ContentRow
            padLevel={padLevel}
            rowId={rowId}
            actions={(
                <RowActions
                    iconPadding="3px"
                    gapBetweenActions="small"
                    actions={getActions()}
                />
            )}
        >
            <Box>
                <ValueText>
                    {`${formatMessage(cableAndFiberMessages.fiberLong)}: `}
                    {fiber ? `${formatMessage(cableAndFiberMessages.cableLong)} ${cableSequence}
                    (${fiber.container.fiber_count.name}, ${fiber.container.reserve || '0'} m) / 
                    ${formatMessage(cableAndFiberMessages.fiberLong)} ${fiber.sequence_number}`
                        : formatMessage(cableAndFiberMessages.disconnectedFiber)}
                </ValueText>
            </Box>
        </ContentRow>
    );
};

OpticalPortSplicedFiberRow.defaultProps = {
    padLevel: null,
    allowSplicing: true,
    loading: false,
};

export default withRouter(injectIntl(OpticalPortSplicedFiberRow));
